import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import { to, getUrlParameters, getPathname } from 'helpers/url-helpers'
import Backbone from 'init/backbone'
import { currencies } from 'init/currencies'
import { currentCurrency } from 'init/current-currency'
import $ from 'init/jquery'
import each from 'lodash/each'
import extend from 'lodash/extend'

@Defaults({
  router: null,
  templateId: '#currency-select-list',
  events: {
    'click .choice-currency': 'choiceCurrency',
  },
  additionalOptions: ['router', 'templateId'],
})
export class CurrencySelectListView extends View {
  /**
   * @inheritDoc
   */
  run () {
    if (this.templateId) {
      this.template = getTemplate(this.templateId)
    }
    this.listenTo(Backbone, 'change-currency', this.render)
    this.listenTo(Backbone, 'reset-currency', this.render)
    if (this.router) {
      this.$('a').addClass('js-no-rewrite-link')
    }
  }

  /**
   * Обработчик выбора валюты
   * @param {Event} e
   */
  choiceCurrency (e) {
    if (this.router) {
      let target = $(e.currentTarget),
        currency
      if (target.length) {
        currency = target.data('currency')

        if (currency) {
          currencies.setCurrent(currency)
          extend(currentCurrency, currencies.getCurrent().toJSON())
          Backbone.trigger('change-currency')
          if (this.router) {
            this.router.navigate(
              this.router.getPathFragment(),
              { trigger: true },
              { currency: currency }
            )
          }
        }
        e.preventDefault()
      }
    }
  }

  /**
   * @inheritDoc
   */
  render () {
    let currencies = this.model.toJSON()
    let params = getUrlParameters()
    delete params.q
    // Добавляем корректные url в данные для рендеринга
    currencies = each(currencies, currency => {
      let urlParams = to(
        '/',
        {},
        { ...params, currency: currency.name },
      )
      if (urlParams.indexOf('/') === 0) {
        urlParams = urlParams.slice(1)
      }
      currency.url = getPathname() + urlParams
    })
    this.$el.html(this.template({
      isNewPopup: this.isNewPopup || null,
      currencies: currencies,
      current: currentCurrency.name,
      noRewriteLinks: !!this.router,
    }))
  }
}
